<template>
    <div 
        class="o-floor-cover"
        :style="componentStyles"
    >
        <div>
            <MapLabel
                :selectedUnit="getDenormalisedTerminal.unit.name"
                target="unit"
                :offsetX="0"
                :offsetY="0"
                position-x="middle"
                position-y="middle"
            >
                <div class="o-floor-cover__image"></div>
            </MapLabel>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MapLabel from "../../../shared/components/map-viewer/labels/map-label"

export default {
    name: "OFloorCover",
    components: {
        MapLabel,
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp',
            'getDenormalisedTerminal'
        ]),
        componentStyles() {
            return this.getMapConfigProp(`components.OFloorCover.styles`) || {};
        },
        componentParams() {
            return this.getMapConfigProp(`components.OFloorCover.params`) || {};
        }
    }
}
</script>

<style lang="scss">
@import "o-floor-cover";
</style>
